import React, { type JSX } from 'react';
import mutation from './ChangeUtdelningar.gql';
import {
  SetGemensamUtdelningBulkVariables as IVariables,
  SetGemensamUtdelningBulk as IResult,
} from './_QueryTypes/SetGemensamUtdelningBulk';
import {
  IRapportUtdelning,
  IGrundurval,
} from '../../Queries/AnalysutdelningQuery/AnalysutdelningQuery';
import { Mutation } from '@apollo/client/react/components';
import { MutationFunction as MutationFn } from '@apollo/client';
import { TEDGQInputAvenySetGemensamUtdelningArgs } from '../../../../../../../globalQueryTypes';

interface IProps {
  children: (changeUtdelningar: ChangeUtdelningarMutationFnType) => JSX.Element;
}

export type ChangeUtdelningarMutationFnType = (
  analyser: IRapportUtdelning[]
) => void;

export const EMPTY_URVAL: IGrundurval = {
  id: null,
  name: '(Inget grundurval)',
  standardGrundurval: false,
};

const frontendToBackendConversion = (
  analyser: IRapportUtdelning[]
): TEDGQInputAvenySetGemensamUtdelningArgs[] => {
  return analyser.map(
    (analys): TEDGQInputAvenySetGemensamUtdelningArgs => ({
      analys_id: analys.id,
      grundurval_id: analys.grundUrval
        ? analys.grundUrval.id === EMPTY_URVAL.id
          ? null
          : analys.grundUrval.id
        : null,
      tillganglig_ek_analys: analys.availableForAnalys,
      user_start_ek_analys: analys.startAnalysForNewUser,
      user_default_ek_analys: analys.defaultForNewUser,
    })
  );
};

const ChangeUtdelningar: React.FunctionComponent<IProps> = props => {
  const changeUtdelningar =
    (
      mutationFn: MutationFn<IResult, IVariables>
    ): ChangeUtdelningarMutationFnType =>
    analyser => {
      mutationFn({
        variables: {
          analysInfos: frontendToBackendConversion(analyser),
        },
      });
    };

  return (
    <Mutation<IResult, IVariables> mutation={mutation}>
      {mutationFn => {
        return props.children(changeUtdelningar(mutationFn));
      }}
    </Mutation>
  );
};

export default ChangeUtdelningar;
